import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isAudioNode, isAudioParam } from "../util/AdvancedTypeCheck";
import { isDefined } from "../util/TypeCheck";
import { Param } from "./Param";
import { ToneWithContext } from "./ToneWithContext";
import { assert, warn } from "../util/Debug";
/**
 * ToneAudioNode is the base class for classes which process audio.
 */

export var ToneAudioNode = /*#__PURE__*/function (_ToneWithContext) {
  _inherits(ToneAudioNode, _ToneWithContext);

  var _super = _createSuper(ToneAudioNode);

  function ToneAudioNode() {
    var _this;

    _classCallCheck(this, ToneAudioNode);

    _this = _super.apply(this, arguments);
    /**
     * The name of the class
     */

    _this.name = "ToneAudioNode";
    /**
     * List all of the node that must be set to match the ChannelProperties
     */

    _this._internalChannels = [];
    return _this;
  }
  /**
   * The number of inputs feeding into the AudioNode.
   * For source nodes, this will be 0.
   * @example
   * const node = new Tone.Gain();
   * console.log(node.numberOfInputs);
   */


  _createClass(ToneAudioNode, [{
    key: "numberOfInputs",
    get: function get() {
      if (isDefined(this.input)) {
        if (isAudioParam(this.input) || this.input instanceof Param) {
          return 1;
        } else {
          return this.input.numberOfInputs;
        }
      } else {
        return 0;
      }
    }
    /**
     * The number of outputs of the AudioNode.
     * @example
     * const node = new Tone.Gain();
     * console.log(node.numberOfOutputs);
     */

  }, {
    key: "numberOfOutputs",
    get: function get() {
      if (isDefined(this.output)) {
        return this.output.numberOfOutputs;
      } else {
        return 0;
      }
    } //-------------------------------------
    // AUDIO PROPERTIES
    //-------------------------------------

    /**
     * Used to decide which nodes to get/set properties on
     */

  }, {
    key: "_isAudioNode",
    value: function _isAudioNode(node) {
      return isDefined(node) && (node instanceof ToneAudioNode || isAudioNode(node));
    }
    /**
     * Get all of the audio nodes (either internal or input/output) which together
     * make up how the class node responds to channel input/output
     */

  }, {
    key: "_getInternalNodes",
    value: function _getInternalNodes() {
      var nodeList = this._internalChannels.slice(0);

      if (this._isAudioNode(this.input)) {
        nodeList.push(this.input);
      }

      if (this._isAudioNode(this.output)) {
        if (this.input !== this.output) {
          nodeList.push(this.output);
        }
      }

      return nodeList;
    }
    /**
     * Set the audio options for this node such as channelInterpretation
     * channelCount, etc.
     * @param options
     */

  }, {
    key: "_setChannelProperties",
    value: function _setChannelProperties(options) {
      var nodeList = this._getInternalNodes();

      nodeList.forEach(function (node) {
        node.channelCount = options.channelCount;
        node.channelCountMode = options.channelCountMode;
        node.channelInterpretation = options.channelInterpretation;
      });
    }
    /**
     * Get the current audio options for this node such as channelInterpretation
     * channelCount, etc.
     */

  }, {
    key: "_getChannelProperties",
    value: function _getChannelProperties() {
      var nodeList = this._getInternalNodes();

      assert(nodeList.length > 0, "ToneAudioNode does not have any internal nodes"); // use the first node to get properties
      // they should all be the same

      var node = nodeList[0];
      return {
        channelCount: node.channelCount,
        channelCountMode: node.channelCountMode,
        channelInterpretation: node.channelInterpretation
      };
    }
    /**
     * channelCount is the number of channels used when up-mixing and down-mixing
     * connections to any inputs to the node. The default value is 2 except for
     * specific nodes where its value is specially determined.
     */

  }, {
    key: "channelCount",
    get: function get() {
      return this._getChannelProperties().channelCount;
    },
    set: function set(channelCount) {
      var props = this._getChannelProperties(); // merge it with the other properties


      this._setChannelProperties(Object.assign(props, {
        channelCount: channelCount
      }));
    }
    /**
     * channelCountMode determines how channels will be counted when up-mixing and
     * down-mixing connections to any inputs to the node.
     * The default value is "max". This attribute has no effect for nodes with no inputs.
     * * "max" - computedNumberOfChannels is the maximum of the number of channels of all connections to an input. In this mode channelCount is ignored.
     * * "clamped-max" - computedNumberOfChannels is determined as for "max" and then clamped to a maximum value of the given channelCount.
     * * "explicit" - computedNumberOfChannels is the exact value as specified by the channelCount.
     */

  }, {
    key: "channelCountMode",
    get: function get() {
      return this._getChannelProperties().channelCountMode;
    },
    set: function set(channelCountMode) {
      var props = this._getChannelProperties(); // merge it with the other properties


      this._setChannelProperties(Object.assign(props, {
        channelCountMode: channelCountMode
      }));
    }
    /**
     * channelInterpretation determines how individual channels will be treated
     * when up-mixing and down-mixing connections to any inputs to the node.
     * The default value is "speakers".
     */

  }, {
    key: "channelInterpretation",
    get: function get() {
      return this._getChannelProperties().channelInterpretation;
    },
    set: function set(channelInterpretation) {
      var props = this._getChannelProperties(); // merge it with the other properties


      this._setChannelProperties(Object.assign(props, {
        channelInterpretation: channelInterpretation
      }));
    } //-------------------------------------
    // CONNECTIONS
    //-------------------------------------

    /**
     * connect the output of a ToneAudioNode to an AudioParam, AudioNode, or ToneAudioNode
     * @param destination The output to connect to
     * @param outputNum The output to connect from
     * @param inputNum The input to connect to
     */

  }, {
    key: "connect",
    value: function connect(destination) {
      var outputNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var inputNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      _connect(this, destination, outputNum, inputNum);

      return this;
    }
    /**
     * Connect the output to the context's destination node.
     * @example
     * const osc = new Tone.Oscillator("C2").start();
     * osc.toDestination();
     */

  }, {
    key: "toDestination",
    value: function toDestination() {
      this.connect(this.context.destination);
      return this;
    }
    /**
     * Connect the output to the context's destination node.
     * See [[toDestination]]
     * @deprecated
     */

  }, {
    key: "toMaster",
    value: function toMaster() {
      warn("toMaster() has been renamed toDestination()");
      return this.toDestination();
    }
    /**
     * disconnect the output
     */

  }, {
    key: "disconnect",
    value: function disconnect(destination) {
      var outputNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var inputNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      _disconnect(this, destination, outputNum, inputNum);

      return this;
    }
    /**
     * Connect the output of this node to the rest of the nodes in series.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/handdrum-loop.mp3");
     * player.autostart = true;
     * const filter = new Tone.AutoFilter(4).start();
     * const distortion = new Tone.Distortion(0.5);
     * // connect the player to the filter, distortion and then to the master output
     * player.chain(filter, distortion, Tone.Destination);
     */

  }, {
    key: "chain",
    value: function chain() {
      for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
        nodes[_key] = arguments[_key];
      }

      connectSeries.apply(void 0, [this].concat(nodes));
      return this;
    }
    /**
     * connect the output of this node to the rest of the nodes in parallel.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/conga-rhythm.mp3");
     * player.autostart = true;
     * const pitchShift = new Tone.PitchShift(4).toDestination();
     * const filter = new Tone.Filter("G5").toDestination();
     * // connect a node to the pitch shift and filter in parallel
     * player.fan(pitchShift, filter);
     */

  }, {
    key: "fan",
    value: function fan() {
      var _this2 = this;

      for (var _len2 = arguments.length, nodes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nodes[_key2] = arguments[_key2];
      }

      nodes.forEach(function (node) {
        return _this2.connect(node);
      });
      return this;
    }
    /**
     * Dispose and disconnect
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ToneAudioNode.prototype), "dispose", this).call(this);

      if (isDefined(this.input)) {
        if (this.input instanceof ToneAudioNode) {
          this.input.dispose();
        } else if (isAudioNode(this.input)) {
          this.input.disconnect();
        }
      }

      if (isDefined(this.output)) {
        if (this.output instanceof ToneAudioNode) {
          this.output.dispose();
        } else if (isAudioNode(this.output)) {
          this.output.disconnect();
        }
      }

      this._internalChannels = [];
      return this;
    }
  }]);

  return ToneAudioNode;
}(ToneWithContext); //-------------------------------------
// CONNECTIONS
//-------------------------------------

/**
 * connect together all of the arguments in series
 * @param nodes
 */

export function connectSeries() {
  for (var _len3 = arguments.length, nodes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    nodes[_key3] = arguments[_key3];
  }

  var first = nodes.shift();
  nodes.reduce(function (prev, current) {
    if (prev instanceof ToneAudioNode) {
      prev.connect(current);
    } else if (isAudioNode(prev)) {
      _connect(prev, current);
    }

    return current;
  }, first);
}
/**
 * Connect two nodes together so that signal flows from the
 * first node to the second. Optionally specify the input and output channels.
 * @param srcNode The source node
 * @param dstNode The destination node
 * @param outputNumber The output channel of the srcNode
 * @param inputNumber The input channel of the dstNode
 */

function _connect(srcNode, dstNode) {
  var outputNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var inputNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  assert(isDefined(srcNode), "Cannot connect from undefined node");
  assert(isDefined(dstNode), "Cannot connect to undefined node");

  if (dstNode instanceof ToneAudioNode || isAudioNode(dstNode)) {
    assert(dstNode.numberOfInputs > 0, "Cannot connect to node with no inputs");
  }

  assert(srcNode.numberOfOutputs > 0, "Cannot connect from node with no outputs"); // resolve the input of the dstNode

  while (dstNode instanceof ToneAudioNode || dstNode instanceof Param) {
    if (isDefined(dstNode.input)) {
      dstNode = dstNode.input;
    }
  }

  while (srcNode instanceof ToneAudioNode) {
    if (isDefined(srcNode.output)) {
      srcNode = srcNode.output;
    }
  } // make the connection


  if (isAudioParam(dstNode)) {
    srcNode.connect(dstNode, outputNumber);
  } else {
    srcNode.connect(dstNode, outputNumber, inputNumber);
  }
}
/**
 * Disconnect a node from all nodes or optionally include a destination node and input/output channels.
 * @param srcNode The source node
 * @param dstNode The destination node
 * @param outputNumber The output channel of the srcNode
 * @param inputNumber The input channel of the dstNode
 */


export { _connect as connect };

function _disconnect(srcNode, dstNode) {
  var outputNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var inputNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  // resolve the destination node
  if (isDefined(dstNode)) {
    while (dstNode instanceof ToneAudioNode) {
      dstNode = dstNode.input;
    }
  } // resolve the src node


  while (!isAudioNode(srcNode)) {
    if (isDefined(srcNode.output)) {
      srcNode = srcNode.output;
    }
  }

  if (isAudioParam(dstNode)) {
    srcNode.disconnect(dstNode, outputNumber);
  } else if (isAudioNode(dstNode)) {
    srcNode.disconnect(dstNode, outputNumber, inputNumber);
  } else {
    srcNode.disconnect();
  }
}

export { _disconnect as disconnect };